// extracted by mini-css-extract-plugin
module.exports = {"outerContainer":"style_outerContainer__2cA-W"};